export const inquiryTestIds = {
  contactForm: {
    nameInput: "contact-form-name-input",
    emailInput: "contact-form-email-input",
    companyInput: "contact-form-company-name-input",
    contactDetailTextArea: "contact-form-contact-detail-text-area",
    privacyPolicyCheckBox: "contact-form-privacy-policy-checkbox",
    submitButton: "contact-form-submit-button",
  },
} as const;
